window.greenleazeScript = true;

// Greenleaze variables
window.initGreenleazeScript = false;

window.initPriceGreenleaze = false;
var monthValues = [1, 12, 24, 36];
var rawrules = {};
var formated = {};
var priceRules = [];
let tva = 1.2;
let trackingId = null;

const greenleazePriceActualize = new Event("greenleazePriceActualize");
// Greenleaze functions
function parseRule(rule, values) {
  return new Function(
    "return " + rule.replace(/\[\[(\w+)\]\]/g, (_, key) => values[key])
  );
}

function getAllPricesForProduct(productPriceHT) {
  const result = {};
  for (const month of monthValues) {
    result[month] = getRuleByProductPriceAndDuration(productPriceHT, month);
  }
  return result;
}

function getRuleByProductPriceAndDuration(productPriceHT, duration = 36) {
  if (!monthValues.includes(duration))
    duration = monthValues[monthValues.length - 1];
  productPriceFormat = parseFloat(productPriceHT);
  const rule = priceRules.find(
    (priceRule) =>
      priceRule.duration == duration &&
      priceRule.minPrice <= productPriceFormat &&
      priceRule.maxPrice >= productPriceFormat
  );
  if (!rule) {
    console.error("No price rule found", priceRules);
    getAllPriceRules();
    return null;
  }
  const monthlyRule = parseRule(rule.rule, { tva, prixHT: productPriceHT });
  const depositRule = parseRule(rule.depositRule, {
    tva,
    prixHT: productPriceHT,
  });
  return rule
    ? {
        monthly: monthlyRule(),
        initial: depositRule(),
      }
    : { monthly: "0.00", initial: "0.00" };
}

async function getAllPriceRules() {
  const rulesFetch = await fetch("/apps/greenleaze-proxy/pricing", {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
  rawrules = await rulesFetch.json();
  priceRules = rawrules;
  const uniqueDurations = new Set();
  for (let index = 0; index < priceRules.length; index++) {
    uniqueDurations.add(priceRules[index].duration);
  }
  monthValues = [...uniqueDurations].sort(function (a, b) {
    return a - b;
  });
  window.initPriceGreenleaze = true;
  console.log("GREENLEAZE INITIALIZED");
  window.dispatchEvent(greenleazePriceActualize);
  // REFRESH EVENTS
  document.addEventListener("on:cart:add", function (event) {
    console.log("product added");
    setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500);
  });
  document.addEventListener("on:line-item:change", function (event) {
    console.log("product changed");
    setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500);
  });
  document.addEventListener("dispatch:cart-drawer:refresh", function (event) {
    console.log("dispatch:cart-drawer:refresh");
    setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500);
  });
  document.addEventListener("on:cart:error", function (event) {
    console.log("on:cart:error");
    setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500);
  });
}

  async function addTo() {
      var accessoires = $('#voltaireconfigsection240323 #step_4 input[type="checkbox"]:checked');
      var sizeknow = $('#voltaireconfigsection240323 #step_2 input:checked');
      var accessoiresids = [];
      for (let i = 0; i < accessoires.length; i++) {
       if ( sizeknow[0].getAttribute("data-handle") == '26pouces' ){
         accessoiresids.push({id:accessoires[i].value,quantity:1});
       }
       else{
         if ( accessoires[i].getAttribute("data-ids") != '' ){
           accessoiresids.push({id:accessoires[i].getAttribute("data-ids"),quantity:1});
         }
         else{
           accessoiresids.push({id:accessoires[i].value,quantity:1});
         }
       }
      }
      var garantie = $('#voltaireconfigsection240323 #step_5 input[type="checkbox"]:checked');
      var garantieids = [];
      for (let o = 0; o < garantie.length; o++) {
       garantieids.push(garantie[o].value);
      }
  
      var col = $.map(configProduct.product.colors, function(val, key) {
      if (val.handle == configProduct.color)
          return val.handle2;
      });
      
      var data = $.map(configProduct.product.sizes, function(val, key) {
      if (val.handle == configProduct.size)
          return val.handle2;
      });
      
      var finalhandle = data[0]+''+col[0];
      var id = $.map(configProduct.product.variants, function(val, key) {
      if (val.title == finalhandle)
          return val.id;
      });
      var finalid = id[0];

      console.log("final Id", finalid)
      console.log('final accessories', accessoiresids)
      let ack = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				'Access-Control-Allow-Origin': '*',
			},
			body: JSON.stringify({id:finalid,quantity:'1',form_type:"product",utf8:"✓"})
    	});
      


      if (accessoiresids.length > 0){
        for (let o = 0; o < accessoiresids.length; o++) {
          var ide = accessoiresids[o];
            console.log("adding accessory", o, ide)
               await fetch("/cart/add.js", {
        			method: "POST",
        			headers: {
        				"Content-Type": "application/json",
        				'Access-Control-Allow-Origin': '*',
        			},
        			body: JSON.stringify({id:ide.id,quantity:ide.quantity,form_type:"product",utf8:"✓"})
            	});
          }
      }

        console.log("product added", ack)
        return ack
                

    }

async function sendCartAndRedirect(duration, variantId, pdistinctId, isCart = false) {
  if(!isCart)
    await addTo()
  let cartContentsRes = await fetch(window.Shopify.routes.root + "cart.js");
  let cartContents = await cartContentsRes.json();
  if (!trackingId)
    trackingId =
      window.ShopifyAnalytics?.lib?.user?.()?.traits?.()?.uniqToken ||
      self?.crypto?.randomUUID?.();
  let ack = await fetch("/apps/greenleaze-proxy/send-card", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      cartContents: JSON.stringify(cartContents),
      duration: duration,
      trackingId: trackingId,
      trackingData: null,
      postHogtrackingId: pdistinctId,
    }),
  });
  if (ack.ok) {
    ack = await ack.json();
    if (ack?.message) {
      console.error(ack?.message);
      window.postMessage(
        {
          type: "greenleazeError",
          message: ack?.message,
        },
        "*"
      );
      return false;
    }
    if (ack?.redirectUrl) {
      window.location.href = ack?.redirectUrl + "&duration=" + duration;
      return true;
    }
  } else {
    console.error("Une erreur s'est produite.");
    console.error("error during saved ", ack);
    let message = "Une erreur s'est produite.";
    try {
      ack = await ack.json();
      message = ack?.message || "Une erreur s'est produite.";
    } catch (error) {
      console.error("Une erreur s'est produite.");
      console.error("error during saved ", ack);
    }
    window.postMessage(
      {
        type: "greenleazeError",
        message: message,
      },
      "*"
    );
    return false;
  }
}

async function initGreenleaze() {
  console.log("INITIALIAZING GREENLEAZE");
  window.initGreenleazeScript = true;
  await getAllPriceRules();
}

if (!window.initGreenleazeScript) initGreenleaze();

window.addEventListener("message", function (event) {
  console.log(event);

  if (event.data.type === "submitGreenleazeModal") {
    console.log("event", event.data)
    return
    sendCartAndRedirect(
      event.data?.duration
    ).then((success) => {
      if (!success) return;
      document.querySelector(
        "#modal-abonnement-product--greenleaze"
      ).style.display = "none";
    });
  }
});
